<div class="flex flex-col items-center p-[20px] md:p-6 bg-white rounded-lg shadow-lg w-[100vw] md:w-[800px] h-[80vh] md:h-[500px] mt-[20vh] md:mt-[0px] mx-[0px]">
    <div
  class="hidden md:flex rounded-full bg-[var(--dark-blue)] text-white justify-center items-center h-[146px] w-[146px] -mt-[100px]">
       <fa-icon 
  [icon]="faCircleInfo" 
  class="w-[66px] h-[66px] text-white text-[66px] flex">
</fa-icon>
    </div>

    <div class="flex md:hidden justify-end w-full">
        <i class="pi pi-times text-[10px] text-[rgba(194,203,212,1)]" (click)="close()"></i>
    </div>

    <div class="overflow-y-scroll md:overflow-visible w-full">
        <span class="font-bold text-[rgba(74,74,74,1)] text-[30px] block mb-[20px] mt-[4px] md:mt-6 text-center ">Welcome back!</span>

        <div class="md:flex hidden md:flex-col w-full items-center">
            <p class=" mb-0 text-center max-w-[499px] text-[20px] text-[rgba(74,74,74,1)] mb-[35px]">
                It’s been a while since your last visit. We just want to make sure your info is still correct.
            </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3">
            <div *ngIf="this.accountInfo && this.accountInfo!.firstName" class="col-span-1 border-b-2 md:border-b-0 md:border-r-2 border-[rgba(0,123,194,0.5)] pb-[9px] mb-[13px] md:px-[20px] md:mb-[0px] md:pb-[0px]">
                <div class="mb-[15px] text-[20px] text-[rgba(0,123,194,1)] font-bold">Account Info</div>
                <div class="mb-[5px] text-[18px] text-[rgba(74,74,74,1)] whitespace-nowrap"
                [ngClass]="{
                    'md:text-[18px]':this.getFullName().length < 25,
                    'md:text-[16px]':this.getFullName().length >= 25 && this.getFullName().length < 28,
                    'md:text-[12px]':this.getFullName().length >= 28}">
                    {{this.getFullName()}}
                </div>
                <div class="mb-[5px] text-[18px] text-[rgba(74,74,74,1)]">{{this.accountInfo!.mobilePhone}}</div>
                <div class="text-[18px] text-[rgba(74,74,74,1)]"
                [ngClass]="{
                    'md:text-[18px]':this.accountInfo!.email.length < 25,
                    'md:text-[16px]':this.accountInfo!.email.length >= 25 && this.accountInfo!.email.length < 28,
                    'md:text-[12px]':this.accountInfo!.email.length >= 28}">
                    {{this.accountInfo!.email}}
                </div>
            </div>
            <div *ngIf="this.shippingAddressInfo && this.shippingAddressInfo!.address1!=null" class="col-span-1 border-b-2 md:border-b-0 md:border-r-2 border-[rgba(0,123,194,0.5)] pb-[9px] mb-[13px] md:px-[20px] md:mb-[0px] md:pb-[0px]">
                <div class="mb-[15px] text-[20px] text-[rgba(0,123,194,1)] font-bold">Shipping Address</div>
                <div class="mb-[5px] text-[18px] text-[rgba(74,74,74,1)]">{{this.shippingAddressInfo!.address1}}</div>
                <div class="mb-[5px] text-[18px] text-[rgba(74,74,74,1)]">{{this.shippingAddressInfo!.city}}, {{this.shippingAddressInfo!.region}}</div>
                <div class="text-[18px] text-[rgba(74,74,74,1)]">{{this.shippingAddressInfo!.zipCode}}</div>
            </div>
            <div *ngIf="this.creditCardsList" class="col-span-1 md:px-[20px]">
                <div *ngIf="this.creditCardsList.length > 0" class="mb-[15px] text-[20px] text-[rgba(0,123,194,1)] font-bold">Credit Cards</div>
                @for (creditCard of this.creditCardsList!; track $index) {
                <div *ngIf="$index < 3 && creditCard" class="mb-[5px] text-[18px] text-[rgba(74,74,74,1)] grid grid-cols-4 max-w-[300px]">
                    <div class="col-span-2">{{creditCard.creditCardInfo.type}}</div>
                    <div class="col-span-1">{{creditCard.creditCardInfo.lastDigits}}</div>
                    <div class="col-span-1">{{creditCard.expirationMonth | number:'2.0'}}/{{creditCard.expirationYear!.toString()!.substring(2)}}</div>
                </div>
                }
            </div>
        </div>

        <div class="flex flex-col md:items-center">
            <div class="flex grid grid-cols-2 gap-x-[20px] gap-y-[12px] mt-[30px] flex-wrap-reverse md:w-[380px]">
                <div class="md:col-span-1 col-span-2 md:order-0 order-1">
                    <button pButton type="button" (click)="onReject()"
                        class="h-[35px] !font-noto-serif w-full"
                        [outlined]="true">
                        Update Account
                    </button>
                </div>
                <div class="md:col-span-1 col-span-2 md:order-1 order-0 ">
                    <button pButton (click)="close()"
                        class="h-[35px] !font-noto-serif w-full"
                        type="submit" >
                        No Changes
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>